<template>
  <div>
    <v-dialog
      :value="show"
      :persistent="persistent"
      lazy
      :width="$store.state.common.mediumDialogWidth"
      @input="(val) => $emit('update:show', val)"
    >
      <v-card>
        <v-card-title class="pb-0 d-block">
          <v-layout align-center>
            <v-layout
              align-center
              wrap
            >
              <div class="headline mb-2">
                {{ $t('menuAdditivesCreateDialogTitle') }}
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
          <div class="subheading">
            {{ $t('menuAdditivesSubheader') }}
          </div>
        </v-card-title>
        <v-card-text>
          <v-text-field
            ref="new-menu-additive-name-textfield"
            v-model="newMenuAdditiveName"
            :placeholder="$t('name')"
            counter="128"
            :rules="[rules.uniqueName]"
            @keyup.enter="save()"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            round
            flat
            color="msr"
            class="ml-auto"
            :disabled="!newMenuAdditiveFormIsValid"
            @click="save()"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    menuAdditives: {
      type: Array[Object],
      required: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      newMenuAdditiveName: '',
    };
  },
  computed: {
    rules() {
      return {
        uniqueName: (v) => this.isNameUnique(v) || this.$t('nameAlreadyInUse'),
      };
    },
    newMenuAdditiveFormIsValid() {
      return (
        !!this.newMenuAdditiveName &&
        this.newMenuAdditiveName.trim() != '' &&
        this.isNameUnique(this.newMenuAdditiveName)
      );
    },
  },
  watch: {
    show: function (show) {
      if (!show) {
        this.reset();
      } else {
        this.$nextTick(() => {
          this.$refs['new-menu-additive-name-textfield'].focus();
        });
      }
    },
  },
  methods: {
    isNameUnique(name) {
      return !this.menuAdditives
        .map((additive) => additive.name.toLowerCase())
        .includes(name.trim().toLowerCase());
    },
    reset() {
      this.newMenuAdditiveName = '';
    },
    close() {
      this.$emit('update:show', false);
    },
    save() {
      if (!this.newMenuAdditiveFormIsValid) {
        return;
      }
      this.$emit('save', this.newMenuAdditiveName);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu/CreateMenuAdditiveDialog.vue